import { css, styled } from "styled-components";
import { TLearningModeItemDTO } from "../../shared/types/transcript";
import { useState } from "react";
import { Button } from "@blueprintjs/core";
import { useVideoStore } from "../../shared/zustand/video";

type LearningModeContainerProps = {
  qnaData: TLearningModeItemDTO[];
  semanticSearchResult: string;
};

export const LearningModeContainer = (props: LearningModeContainerProps) => {
  const semanticSearchResult = props.semanticSearchResult;
  const qnaData = props.qnaData.filter(
    (qna) => qna.choices.length > 0 && qna.choices.includes(qna.correct_answer)
  );
  const [showAnswer, setShowAnswer] = useState(false);
  const optionLabel = ["A", "B", "C", "D"];

  const playRange = useVideoStore((state) => state.playRange);

  // Play video at the specifc duration
  const playVideoAtRange = async (learningMode: TLearningModeItemDTO) => {
    const startTime = learningMode?.start ?? 0;
    const endTime = learningMode?.end ?? 0;

    playRange(startTime, endTime);
  };

  return (
    <LearningModeWrapper className="space-y-8 p-6">
      {semanticSearchResult && (
        <>
          <b>Answer: </b>
          {props.semanticSearchResult}
        </>
      )}
      {qnaData.map((item, index) => (
        <div key={index} className="border p-4 rounded-xl shadow-sm bg-white">
          {showAnswer && (
            <Button
              style={{ float: "right" }}
              onClick={() => playVideoAtRange(item)}
              icon="volume-up"
              outlined={true}
              aria-label="share"
              intent="primary"
            >
              Audio
            </Button>
          )}
          <h4 className="font-semibold text-lg mb-3">{`${index + 1}. ${item.question}`}</h4>
          <ul className="space-y-2">
            {item.choices.map((choice, i) => (
              <div key={i}>
                <Option
                  $isCorrectAnswer={
                    choice === item.correct_answer && showAnswer
                  }
                >
                  {`${optionLabel[i]}. ${choice}`}
                </Option>
              </div>
            ))}
          </ul>
        </div>
      ))}
      {qnaData.length > 0 && (
        <Button
          style={{ float: "right" }}
          intent="success"
          onClick={() => setShowAnswer(!showAnswer)}
        >
          {showAnswer ? "Hide Answer" : "Show Answer"}
        </Button>
      )}
    </LearningModeWrapper>
  );
};

const LearningModeWrapper = styled.div`
  max-height: calc(100dvh - 250px);
  overflow: auto;
  margin-top: 30px;
`;

const Option = styled.span<{ $isCorrectAnswer?: boolean }>`
  ${(props) =>
    props.$isCorrectAnswer &&
    css`
      color: green;
    `};
`;
